function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import * as e from "leaflet";
function t() {
  return t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t.apply(this, arguments);
}
function r(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, n(e, t);
}
function n(e, t) {
  return n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, n(e, t);
}
function o() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function i(e, t, r) {
  return i = o() ? Reflect.construct.bind() : function (e, t, r) {
    var o = [null];
    o.push.apply(o, t);
    var i = new (Function.bind.apply(e, o))();
    return r && n(i, r.prototype), i;
  }, i.apply(null, arguments);
}
function s(e, t, r, n) {
  void 0 === t && (t = ""), void 0 === n && (n = {});
  var o = document.createElement(e);
  return t && (o.className = t), Object.keys(n).forEach(function (e) {
    if ("function" == typeof n[e]) {
      var t = 0 === e.indexOf("on") ? e.substr(2).toLowerCase() : e;
      o.addEventListener(t, n[e]);
    } else "html" === e ? o.innerHTML = n[e] : "text" === e ? o.innerText = n[e] : o.setAttribute(e, n[e]);
  }), r && r.appendChild(o), o;
}
function a(e) {
  e.preventDefault(), e.stopPropagation();
}
var l = function l() {
  return [].slice.call(arguments).filter(Boolean).join(" ").trim();
};
function c(e, t) {
  e && e.classList && (Array.isArray(t) ? t : [t]).forEach(function (t) {
    e.classList.contains(t) || e.classList.add(t);
  });
}
function u(e, t) {
  e && e.classList && (Array.isArray(t) ? t : [t]).forEach(function (t) {
    e.classList.contains(t) && e.classList.remove(t);
  });
}
var h,
  p = 13,
  d = 40,
  f = 38,
  m = [p, 27, d, f, 37, 39],
  v = /*#__PURE__*/function () {
    function e(e) {
      var t = this,
        r = e.handleSubmit,
        n = e.searchLabel,
        o = e.classNames,
        i = void 0 === o ? {} : o;
      this.container = void 0, this.form = void 0, this.input = void 0, this.handleSubmit = void 0, this.hasError = !1, this.container = s("div", l("geosearch", i.container)), this.form = s("form", ["", i.form].join(" "), this.container, {
        autocomplete: "none",
        onClick: a,
        onDblClick: a,
        touchStart: a,
        touchEnd: a
      }), this.input = s("input", ["glass", i.input].join(" "), this.form, {
        type: "text",
        placeholder: n || "search",
        onInput: this.onInput,
        onKeyUp: function onKeyUp(e) {
          return t.onKeyUp(e);
        },
        onKeyPress: function onKeyPress(e) {
          return t.onKeyPress(e);
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onClick: function onClick() {
          t.input.focus(), t.input.dispatchEvent(new Event("focus"));
        }
      }), this.handleSubmit = r;
    }
    var t = e.prototype;
    return t.onFocus = function () {
      c(this.form, "active");
    }, t.onBlur = function () {
      u(this.form, "active");
    }, t.onSubmit = function (e) {
      try {
        var t = this;
        return a(e), u(r = t.container, "error"), c(r, "pending"), Promise.resolve(t.handleSubmit({
          query: t.input.value
        })).then(function () {
          u(t.container, "pending");
        });
      } catch (e) {
        return Promise.reject(e);
      }
      var r;
    }, t.onInput = function () {
      this.hasError && (u(this.container, "error"), this.hasError = !1);
    }, t.onKeyUp = function (e) {
      27 === e.keyCode && (u(this.container, ["pending", "active"]), this.input.value = "", document.body.focus(), document.body.blur());
    }, t.onKeyPress = function (e) {
      e.keyCode === p && this.onSubmit(e);
    }, t.setQuery = function (e) {
      this.input.value = e;
    }, e;
  }(),
  g = /*#__PURE__*/function () {
    function e(e) {
      var t = this,
        r = e.handleClick,
        n = e.classNames,
        o = void 0 === n ? {} : n,
        i = e.notFoundMessage;
      this.handleClick = void 0, this.selected = -1, this.results = [], this.container = void 0, this.resultItem = void 0, this.notFoundMessage = void 0, this.onClick = function (e) {
        if ("function" == typeof t.handleClick) {
          var r = e.target;
          if (r && t.container.contains(r) && r.hasAttribute("data-key")) {
            var n = Number(r.getAttribute("data-key"));
            t.handleClick({
              result: t.results[n]
            });
          }
        }
      }, this.handleClick = r, this.notFoundMessage = i ? s("div", l(o.notfound), void 0, {
        html: i
      }) : void 0, this.container = s("div", l("results", o.resultlist)), this.container.addEventListener("click", this.onClick, !0), this.resultItem = s("div", l(o.item));
    }
    var t = e.prototype;
    return t.render = function (e, t) {
      var r = this;
      void 0 === e && (e = []), this.clear(), e.forEach(function (e, n) {
        var o = r.resultItem.cloneNode(!0);
        o.setAttribute("data-key", "" + n), o.innerHTML = t({
          result: e
        }), r.container.appendChild(o);
      }), e.length > 0 ? (c(this.container.parentElement, "open"), c(this.container, "active")) : this.notFoundMessage && (this.container.appendChild(this.notFoundMessage), c(this.container.parentElement, "open")), this.results = e;
    }, t.select = function (e) {
      return Array.from(this.container.children).forEach(function (t, r) {
        return r === e ? c(t, "active") : u(t, "active");
      }), this.selected = e, this.results[e];
    }, t.count = function () {
      return this.results ? this.results.length : 0;
    }, t.clear = function () {
      for (this.selected = -1; this.container.lastChild;) this.container.removeChild(this.container.lastChild);
      u(this.container.parentElement, "open"), u(this.container, "active");
    }, e;
  }(),
  y = {
    position: "topleft",
    style: "button",
    showMarker: !0,
    showPopup: !1,
    popupFormat: function popupFormat(e) {
      return "" + e.result.label;
    },
    resultFormat: function resultFormat(e) {
      return "" + e.result.label;
    },
    marker: {
      icon: e && e.Icon ? new e.Icon.Default() : void 0,
      draggable: !1
    },
    maxMarkers: 1,
    maxSuggestions: 5,
    retainZoomLevel: !1,
    animateZoom: !0,
    searchLabel: "Enter address",
    clearSearchLabel: "Clear search",
    notFoundMessage: "",
    messageHideDelay: 3e3,
    zoomLevel: 18,
    classNames: {
      container: "leaflet-bar leaflet-control leaflet-control-geosearch",
      button: "leaflet-bar-part leaflet-bar-part-single",
      resetButton: "reset",
      msgbox: "leaflet-bar message",
      form: "",
      input: "",
      resultlist: "",
      item: "",
      notfound: "leaflet-bar-notfound"
    },
    autoComplete: !0,
    autoCompleteDelay: 250,
    autoClose: !1,
    keepResult: !1,
    updateMap: !0
  },
  b = "Leaflet must be loaded before instantiating the GeoSearch control",
  E = {
    options: t({}, y),
    classNames: t({}, y.classNames),
    initialize: function initialize(r) {
      var n,
        o,
        i,
        a,
        l = this;
      if (!e) throw new Error(b);
      if (!r.provider) throw new Error("Provider is missing from options");
      this.options = t({}, y, r), this.classNames = t({}, this.classNames, r.classNames), this.markers = new e.FeatureGroup(), this.classNames.container += " leaflet-geosearch-" + this.options.style, this.searchElement = new v({
        searchLabel: this.options.searchLabel,
        classNames: {
          container: this.classNames.container,
          form: this.classNames.form,
          input: this.classNames.input
        },
        handleSubmit: function handleSubmit(e) {
          return l.onSubmit(e);
        }
      }), this.button = s("a", this.classNames.button, this.searchElement.container, {
        title: this.options.searchLabel,
        href: "#",
        onClick: function onClick(e) {
          return l.onClick(e);
        }
      }), e.DomEvent.disableClickPropagation(this.button), this.resetButton = s("button", this.classNames.resetButton, this.searchElement.form, {
        text: "×",
        "aria-label": this.options.clearSearchLabel,
        onClick: function onClick() {
          "" === l.searchElement.input.value ? l.close() : l.clearResults(null, !0);
        }
      }), e.DomEvent.disableClickPropagation(this.resetButton), this.options.autoComplete && (this.resultList = new g({
        handleClick: function handleClick(e) {
          var t = e.result;
          l.searchElement.input.value = t.label, l.onSubmit({
            query: t.label,
            data: t
          });
        },
        classNames: {
          resultlist: this.classNames.resultlist,
          item: this.classNames.item,
          notfound: this.classNames.notfound
        },
        notFoundMessage: this.options.notFoundMessage
      }), this.searchElement.form.appendChild(this.resultList.container), this.searchElement.input.addEventListener("keyup", (n = function n(e) {
        return l.autoSearch(e);
      }, void 0 === (o = this.options.autoCompleteDelay) && (o = 250), void 0 === i && (i = !1), function () {
        var e = [].slice.call(arguments);
        a && clearTimeout(a), a = setTimeout(function () {
          a = null, i || n.apply(void 0, e);
        }, o), i && !a && n.apply(void 0, e);
      }), !0), this.searchElement.input.addEventListener("keydown", function (e) {
        return l.selectResult(e);
      }, !0), this.searchElement.input.addEventListener("keydown", function (e) {
        return l.clearResults(e, !0);
      }, !0)), this.searchElement.form.addEventListener("click", function (e) {
        e.preventDefault();
      }, !1);
    },
    onAdd: function onAdd(t) {
      var r = this.options,
        n = r.showMarker,
        o = r.style;
      if (this.map = t, n && this.markers.addTo(t), "bar" === o) {
        var i = t.getContainer().querySelector(".leaflet-control-container");
        this.container = s("div", "leaflet-control-geosearch leaflet-geosearch-bar"), this.container.appendChild(this.searchElement.form), i.appendChild(this.container);
      }
      return e.DomEvent.disableClickPropagation(this.searchElement.form), this.searchElement.container;
    },
    onRemove: function onRemove() {
      var e;
      return null == (e = this.container) || e.remove(), this;
    },
    open: function open() {
      var e = this.searchElement,
        t = e.input;
      c(e.container, "active"), t.focus();
    },
    close: function close() {
      u(this.searchElement.container, "active"), this.clearResults();
    },
    onClick: function onClick(e) {
      e.preventDefault(), e.stopPropagation(), this.searchElement.container.classList.contains("active") ? this.close() : this.open();
    },
    selectResult: function selectResult(e) {
      if (-1 !== [p, d, f].indexOf(e.keyCode)) if (e.preventDefault(), e.keyCode !== p) {
        var t = this.resultList.count() - 1;
        if (!(t < 0)) {
          var r = this.resultList.selected,
            n = e.keyCode === d ? r + 1 : r - 1,
            o = this.resultList.select(n < 0 ? t : n > t ? 0 : n);
          this.searchElement.input.value = o.label;
        }
      } else {
        var i = this.resultList.select(this.resultList.selected);
        this.onSubmit({
          query: this.searchElement.input.value,
          data: i
        });
      }
    },
    clearResults: function clearResults(e, t) {
      if (void 0 === t && (t = !1), !e || 27 === e.keyCode) {
        var r = this.options,
          n = r.autoComplete;
        !t && r.keepResult || (this.searchElement.input.value = "", this.markers.clearLayers()), n && this.resultList.clear();
      }
    },
    autoSearch: function autoSearch(e) {
      try {
        var t = this;
        if (m.indexOf(e.keyCode) > -1) return Promise.resolve();
        var r = e.target.value,
          n = t.options.provider,
          o = function () {
            if (r.length) return Promise.resolve(n.search({
              query: r
            })).then(function (e) {
              e = e.slice(0, t.options.maxSuggestions), t.resultList.render(e, t.options.resultFormat);
            });
            t.resultList.clear();
          }();
        return Promise.resolve(o && o.then ? o.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    onSubmit: function onSubmit(e) {
      try {
        var t = this;
        return t.resultList.clear(), Promise.resolve(t.options.provider.search(e)).then(function (r) {
          r && r.length > 0 && t.showResult(r[0], e);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    showResult: function showResult(e, t) {
      var r = this.options,
        n = r.autoClose,
        o = r.updateMap,
        i = this.markers.getLayers();
      i.length >= this.options.maxMarkers && this.markers.removeLayer(i[0]);
      var s = this.addMarker(e, t);
      o && this.centerMap(e), this.map.fireEvent("geosearch/showlocation", {
        location: e,
        marker: s
      }), n && this.closeResults();
    },
    closeResults: function closeResults() {
      var e = this.searchElement.container;
      e.classList.contains("active") && u(e, "active"), this.clearResults();
    },
    addMarker: function addMarker(t, r) {
      var n = this,
        o = this.options,
        i = o.marker,
        s = o.showPopup,
        a = o.popupFormat,
        l = new e.Marker([t.y, t.x], i),
        c = t.label;
      return "function" == typeof a && (c = a({
        query: r,
        result: t
      })), l.bindPopup(c), this.markers.addLayer(l), s && l.openPopup(), i.draggable && l.on("dragend", function (e) {
        n.map.fireEvent("geosearch/marker/dragend", {
          location: l.getLatLng(),
          event: e
        });
      }), l;
    },
    centerMap: function centerMap(t) {
      var r = this.options,
        n = r.retainZoomLevel,
        o = r.animateZoom,
        i = t.bounds ? new e.LatLngBounds(t.bounds) : new e.LatLng(t.y, t.x).toBounds(10),
        s = i.isValid() ? i : this.markers.getBounds();
      !n && i.isValid() && !t.bounds || n || !i.isValid() ? this.map.setView(s.getCenter(), this.getZoom(), {
        animate: o
      }) : this.map.fitBounds(s, {
        animate: o
      });
    },
    getZoom: function getZoom() {
      var e = this.options,
        t = e.zoomLevel;
      return e.retainZoomLevel ? this.map.getZoom() : t;
    }
  };
function w() {
  if (!e) throw new Error(b);
  var t = e.Control.extend(E);
  return i(t, [].slice.call(arguments));
}
!function (e) {
  e[e.SEARCH = 0] = "SEARCH", e[e.REVERSE = 1] = "REVERSE";
}(h || (h = {}));
var x = /*#__PURE__*/function () {
    function e(e) {
      void 0 === e && (e = {}), this.options = void 0, this.options = e;
    }
    var r = e.prototype;
    return r.getParamString = function (e) {
      void 0 === e && (e = {});
      var r = t({}, this.options.params, e);
      return Object.keys(r).map(function (e) {
        return encodeURIComponent(e) + "=" + encodeURIComponent(r[e]);
      }).join("&");
    }, r.getUrl = function (e, t) {
      return e + "?" + this.getParamString(t);
    }, r.search = function (e) {
      try {
        var t = this,
          r = t.endpoint({
            query: e.query,
            type: h.SEARCH
          });
        return Promise.resolve(fetch(r)).then(function (e) {
          return Promise.resolve(e.json()).then(function (e) {
            return t.parse({
              data: e
            });
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }, e;
  }(),
  k = /*#__PURE__*/function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (t = e.call.apply(e, [this].concat(n)) || this).searchUrl = "https://dev.virtualearth.net/REST/v1/Locations", t;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = "string" == typeof t ? {
          q: t
        } : t;
      return r.jsonp = e.jsonp, this.getUrl(this.searchUrl, r);
    }, n.parse = function (e) {
      return 0 === e.data.resourceSets.length ? [] : e.data.resourceSets[0].resources.map(function (e) {
        return {
          x: e.point.coordinates[1],
          y: e.point.coordinates[0],
          label: e.address.formattedAddress,
          bounds: [[e.bbox[0], e.bbox[1]], [e.bbox[2], e.bbox[3]]],
          raw: e
        };
      });
    }, n.search = function (e) {
      var t,
        r,
        n,
        o = e.query;
      try {
        var i = this,
          a = "BING_JSONP_CB_" + Date.now();
        return Promise.resolve((t = i.endpoint({
          query: o,
          jsonp: a
        }), r = a, n = s("script", null, document.body), n.setAttribute("type", "text/javascript"), new Promise(function (e) {
          window[r] = function (t) {
            n.remove(), delete window[r], e(t);
          }, n.setAttribute("src", t);
        }))).then(function (e) {
          return i.parse({
            data: e
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }, t;
  }(x),
  U = /*#__PURE__*/function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (t = e.call.apply(e, [this].concat(n)) || this).searchUrl = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/find", t;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = "string" == typeof t ? {
          text: t
        } : t;
      return r.f = "json", this.getUrl(this.searchUrl, r);
    }, n.parse = function (e) {
      return e.data.locations.map(function (e) {
        return {
          x: e.feature.geometry.x,
          y: e.feature.geometry.y,
          label: e.name,
          bounds: [[e.extent.ymin, e.extent.xmin], [e.extent.ymax, e.extent.xmax]],
          raw: e
        };
      });
    }, t;
  }(x),
  L = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      return void 0 === t && (t = {}), (r = e.call(this, t) || this).host = void 0, r.host = t.host || "http://localhost:4000", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query;
      return e.type === h.REVERSE ? this.getUrl(this.host + "/v1/reverse", "string" == typeof t ? {} : t) : this.getUrl(this.host + "/v1/autocomplete", "string" == typeof t ? {
        text: t
      } : t);
    }, n.parse = function (e) {
      return e.data.features.map(function (e) {
        var t = {
          x: e.geometry.coordinates[0],
          y: e.geometry.coordinates[1],
          label: e.properties.label,
          bounds: null,
          raw: e
        };
        return Array.isArray(e.bbox) && 4 === e.bbox.length && (t.bounds = [[e.bbox[1], e.bbox[0]], [e.bbox[3], e.bbox[2]]]), t;
      });
    }, t;
  }(x),
  S = /*#__PURE__*/function (e) {
    function t(t) {
      return void 0 === t && (t = {}), t.host = "https://api.geocode.earth", e.call(this, t) || this;
    }
    return r(t, e), t;
  }(L);
function C(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
"function" == typeof SuppressedError && SuppressedError;
var P,
  R = /*@__PURE__*/C(function e(t, r) {
    if (t === r) return !0;
    if (t && r && "object" == _typeof(t) && "object" == _typeof(r)) {
      if (t.constructor !== r.constructor) return !1;
      var n, o, i;
      if (Array.isArray(t)) {
        if ((n = t.length) != r.length) return !1;
        for (o = n; 0 != o--;) if (!e(t[o], r[o])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
      if ((n = (i = Object.keys(t)).length) !== Object.keys(r).length) return !1;
      for (o = n; 0 != o--;) if (!Object.prototype.hasOwnProperty.call(r, i[o])) return !1;
      for (o = n; 0 != o--;) {
        var s = i[o];
        if (!e(t[s], r[s])) return !1;
      }
      return !0;
    }
    return t != t && r != r;
  });
!function (e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
}(P || (P = {}));
var j = /*#__PURE__*/function () {
  function j(_ref) {
    var e = _ref.apiKey,
      t = _ref.authReferrerPolicy,
      r = _ref.channel,
      n = _ref.client,
      _ref$id = _ref.id,
      o = _ref$id === void 0 ? "__googleMapsScriptId" : _ref$id,
      i = _ref.language,
      _ref$libraries = _ref.libraries,
      s = _ref$libraries === void 0 ? [] : _ref$libraries,
      a = _ref.mapIds,
      l = _ref.nonce,
      c = _ref.region,
      _ref$retries = _ref.retries,
      u = _ref$retries === void 0 ? 3 : _ref$retries,
      _ref$url = _ref.url,
      h = _ref$url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _ref$url,
      p = _ref.version;
    _classCallCheck(this, j);
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = t, this.channel = r, this.client = n, this.id = o || "__googleMapsScriptId", this.language = i, this.libraries = s, this.mapIds = a, this.nonce = l, this.region = c, this.retries = u, this.url = h, this.version = p, j.instance) {
      if (!R(this.options, j.instance.options)) throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(j.instance.options)));
      return j.instance;
    }
    j.instance = this;
  }
  _createClass(j, [{
    key: "options",
    get: function get() {
      return {
        version: this.version,
        apiKey: this.apiKey,
        channel: this.channel,
        client: this.client,
        id: this.id,
        libraries: this.libraries,
        language: this.language,
        region: this.region,
        mapIds: this.mapIds,
        nonce: this.nonce,
        url: this.url,
        authReferrerPolicy: this.authReferrerPolicy
      };
    }
  }, {
    key: "status",
    get: function get() {
      return this.errors.length ? P.FAILURE : this.done ? P.SUCCESS : this.loading ? P.LOADING : P.INITIALIZED;
    }
  }, {
    key: "failed",
    get: function get() {
      return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
  }, {
    key: "createUrl",
    value: function createUrl() {
      var e = this.url;
      return e += "?callback=__googleMapsCallback&loading=async", this.apiKey && (e += "&key=".concat(this.apiKey)), this.channel && (e += "&channel=".concat(this.channel)), this.client && (e += "&client=".concat(this.client)), this.libraries.length > 0 && (e += "&libraries=".concat(this.libraries.join(","))), this.language && (e += "&language=".concat(this.language)), this.region && (e += "&region=".concat(this.region)), this.version && (e += "&v=".concat(this.version)), this.mapIds && (e += "&map_ids=".concat(this.mapIds.join(","))), this.authReferrerPolicy && (e += "&auth_referrer_policy=".concat(this.authReferrerPolicy)), e;
    }
  }, {
    key: "deleteScript",
    value: function deleteScript() {
      var e = document.getElementById(this.id);
      e && e.remove();
    }
  }, {
    key: "load",
    value: function load() {
      return this.loadPromise();
    }
  }, {
    key: "loadPromise",
    value: function loadPromise() {
      var _this = this;
      return new Promise(function (e, t) {
        _this.loadCallback(function (r) {
          r ? t(r.error) : e(window.google);
        });
      });
    }
  }, {
    key: "importLibrary",
    value: function importLibrary(e) {
      return this.execute(), google.maps.importLibrary(e);
    }
  }, {
    key: "loadCallback",
    value: function loadCallback(e) {
      this.callbacks.push(e), this.execute();
    }
  }, {
    key: "setScript",
    value: function setScript() {
      var _this2 = this;
      var e, t;
      if (document.getElementById(this.id)) return void this.callback();
      var r = {
        key: this.apiKey,
        channel: this.channel,
        client: this.client,
        libraries: this.libraries.length && this.libraries,
        v: this.version,
        mapIds: this.mapIds,
        language: this.language,
        region: this.region,
        authReferrerPolicy: this.authReferrerPolicy
      };
      Object.keys(r).forEach(function (e) {
        return !r[e] && delete r[e];
      }), (null === (t = null === (e = null === window || void 0 === window ? void 0 : window.google) || void 0 === e ? void 0 : e.maps) || void 0 === t ? void 0 : t.importLibrary) || function (e) {
        var t,
          r,
          n,
          o = "The Google Maps JavaScript API",
          i = "google",
          s = "importLibrary",
          a = "__ib__",
          l = document,
          c = window;
        c = c[i] || (c[i] = {});
        var u = c.maps || (c.maps = {}),
          h = new Set(),
          p = new URLSearchParams(),
          d = function d() {
            return t || (t = new Promise(function (s, c) {
              return d = _this2, m = /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var d;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return r = l.createElement("script");
                    case 2:
                      r.id = this.id;
                      p.set("libraries", _toConsumableArray(h) + "");
                      _context.t0 = _regeneratorRuntime().keys(e);
                    case 5:
                      if ((_context.t1 = _context.t0()).done) {
                        _context.next = 10;
                        break;
                      }
                      n = _context.t1.value;
                      p.set(n.replace(/[A-Z]/g, function (e) {
                        return "_" + e[0].toLowerCase();
                      }), e[n]);
                      _context.next = 5;
                      break;
                    case 10:
                      p.set("callback", i + ".maps." + a), r.src = this.url + "?" + p, u[a] = s, r.onerror = function () {
                        return t = c(Error(o + " could not load."));
                      }, r.nonce = this.nonce || (null === (d = l.querySelector("script[nonce]")) || void 0 === d ? void 0 : d.nonce) || "", l.head.append(r);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, this);
              }), new ((f = void 0) || (f = Promise))(function (e, t) {
                function r(e) {
                  try {
                    o(m.next(e));
                  } catch (e) {
                    t(e);
                  }
                }
                function n(e) {
                  try {
                    o(m.throw(e));
                  } catch (e) {
                    t(e);
                  }
                }
                function o(t) {
                  var o;
                  t.done ? e(t.value) : (o = t.value, o instanceof f ? o : new f(function (e) {
                    e(o);
                  })).then(r, n);
                }
                o((m = m.apply(d, [])).next());
              });
              var d, f, m;
            }));
          };
        u[s] ? console.warn(o + " only loads once. Ignoring:", e) : u[s] = function (e) {
          for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            t[_key - 1] = arguments[_key];
          }
          return h.add(e) && d().then(function () {
            return u[s].apply(u, [e].concat(t));
          });
        };
      }(r);
      var n = this.libraries.map(function (e) {
        return _this2.importLibrary(e);
      });
      n.length || n.push(this.importLibrary("core")), Promise.all(n).then(function () {
        return _this2.callback();
      }, function (e) {
        var t = new ErrorEvent("error", {
          error: e
        });
        _this2.loadErrorCallback(t);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
    }
  }, {
    key: "resetIfRetryingFailed",
    value: function resetIfRetryingFailed() {
      this.failed && this.reset();
    }
  }, {
    key: "loadErrorCallback",
    value: function loadErrorCallback(e) {
      var _this3 = this;
      if (this.errors.push(e), this.errors.length <= this.retries) {
        var _e = this.errors.length * Math.pow(2, this.errors.length);
        console.error("Failed to load Google Maps script, retrying in ".concat(_e, " ms.")), setTimeout(function () {
          _this3.deleteScript(), _this3.setScript();
        }, _e);
      } else this.onerrorEvent = e, this.callback();
    }
  }, {
    key: "callback",
    value: function callback() {
      var _this4 = this;
      this.done = !0, this.loading = !1, this.callbacks.forEach(function (e) {
        e(_this4.onerrorEvent);
      }), this.callbacks = [];
    }
  }, {
    key: "execute",
    value: function execute() {
      if (this.resetIfRetryingFailed(), this.done) this.callback();else {
        if (window.google && window.google.maps && window.google.maps.version) return console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), void this.callback();
        this.loading || (this.loading = !0, this.setScript());
      }
    }
  }]);
  return j;
}();
var A = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      return (r = e.call(this, t) || this).loader = null, r.geocoder = null, "undefined" != typeof window && (r.loader = new j(t).load().then(function (e) {
        var t = new e.maps.Geocoder();
        return r.geocoder = t, t;
      })), r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      throw new Error("Method not implemented.");
    }, n.parse = function (e) {
      return e.data.results.map(function (e) {
        var t = e.geometry.location.toJSON(),
          r = t.lat,
          n = t.lng,
          o = e.geometry.viewport.toJSON();
        return {
          x: n,
          y: r,
          label: e.formatted_address,
          bounds: [[o.south, o.west], [o.north, o.east]],
          raw: e
        };
      });
    }, n.search = function (e) {
      try {
        var t = function t(_t) {
            if (!_t) throw new Error("GoogleMaps GeoCoder is not loaded. Are you trying to run this server side?");
            return Promise.resolve(_t.geocode({
              address: e.query
            }, function (e) {
              return {
                results: e
              };
            }).catch(function (e) {
              return "ZERO_RESULTS" !== e.code && console.error(e.code + ": " + e.message), {
                results: []
              };
            })).then(function (e) {
              return r.parse({
                data: e
              });
            });
          },
          r = this,
          n = r.geocoder;
        return Promise.resolve(n ? t(n) : Promise.resolve(r.loader).then(t));
      } catch (e) {
        return Promise.reject(e);
      }
    }, t;
  }(x),
  I = /*#__PURE__*/function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (t = e.call.apply(e, [this].concat(n)) || this).searchUrl = "https://maps.googleapis.com/maps/api/geocode/json", t;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query;
      return this.getUrl(this.searchUrl, "string" == typeof t ? {
        address: t
      } : t);
    }, n.parse = function (e) {
      return e.data.results.map(function (e) {
        return {
          x: e.geometry.location.lng,
          y: e.geometry.location.lat,
          label: e.formatted_address,
          bounds: [[e.geometry.viewport.southwest.lat, e.geometry.viewport.southwest.lng], [e.geometry.viewport.northeast.lat, e.geometry.viewport.northeast.lng]],
          raw: e
        };
      });
    }, t;
  }(x),
  N = /*#__PURE__*/function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (t = e.call.apply(e, [this].concat(n)) || this).searchUrl = "https://geocode.search.hereapi.com/v1/autosuggest", t;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query;
      return this.getUrl(this.searchUrl, "string" == typeof t ? {
        q: t
      } : t);
    }, n.parse = function (e) {
      return e.data.items.filter(function (e) {
        return void 0 !== e.position;
      }).map(function (e) {
        return {
          x: e.position.lng,
          y: e.position.lat,
          label: e.address.label,
          bounds: null,
          raw: e
        };
      });
    }, t;
  }(x),
  F = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      void 0 === t && (t = {}), (r = e.call(this, t) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://nominatim.openstreetmap.org";
      return r.searchUrl = t.searchUrl || n + "/search", r.reverseUrl = t.reverseUrl || n + "/reverse", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = e.type,
        n = "string" == typeof t ? {
          q: t
        } : t;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (e) {
      return (Array.isArray(e.data) ? e.data : [e.data]).map(function (e) {
        return {
          x: Number(e.lon),
          y: Number(e.lat),
          label: e.display_name,
          bounds: [[parseFloat(e.boundingbox[0]), parseFloat(e.boundingbox[2])], [parseFloat(e.boundingbox[1]), parseFloat(e.boundingbox[3])]],
          raw: e
        };
      });
    }, t;
  }(x),
  O = /*#__PURE__*/function (e) {
    function n(r) {
      return e.call(this, t({}, r, {
        searchUrl: "https://locationiq.org/v1/search.php",
        reverseUrl: "https://locationiq.org/v1/reverse.php"
      })) || this;
    }
    return r(n, e), n.prototype.parse = function (t) {
      return t.data.error ? [] : e.prototype.parse.call(this, t);
    }, n;
  }(F),
  q = /*#__PURE__*/function (e) {
    function t() {
      for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (t = e.call.apply(e, [this].concat(n)) || this).searchUrl = "https://api.opencagedata.com/geocode/v1/json", t;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = "string" == typeof t ? {
          q: t
        } : t;
      return r.format = "json", this.getUrl(this.searchUrl, r);
    }, n.parse = function (e) {
      return e.data.results.map(function (e) {
        return {
          x: e.geometry.lng,
          y: e.geometry.lat,
          label: e.formatted,
          bounds: [[e.bounds.southwest.lat, e.bounds.southwest.lng], [e.bounds.northeast.lat, e.bounds.northeast.lng]],
          raw: e
        };
      });
    }, n.search = function (t) {
      try {
        return Promise.resolve(t.query.length < 2 ? [] : e.prototype.search.call(this, t));
      } catch (e) {
        return Promise.reject(e);
      }
    }, t;
  }(x),
  M = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      void 0 === t && (t = {}), (r = e.call(this, t) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://civildefense.fit.vutbr.cz";
      return r.searchUrl = t.searchUrl || n + "/search", r.reverseUrl = t.reverseUrl || n + "/reverse", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = e.type,
        n = "string" == typeof t ? {
          q: t
        } : t;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (e) {
      return (Array.isArray(e.data) ? e.data : [e.data]).map(function (e) {
        return {
          x: Number(e.lon),
          y: Number(e.lat),
          label: e.display_name,
          bounds: [[parseFloat(e.boundingbox[0]), parseFloat(e.boundingbox[2])], [parseFloat(e.boundingbox[1]), parseFloat(e.boundingbox[3])]],
          raw: e
        };
      });
    }, t;
  }(x),
  _ = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      return void 0 === t && (t = {}), (r = e.call(this, t) || this).searchUrl = void 0, r.searchUrl = t.searchUrl || "https://a.tiles.mapbox.com/v4/geocode/mapbox.places/", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      return this.getUrl("" + this.searchUrl + e.query + ".json");
    }, n.parse = function (e) {
      return (Array.isArray(e.data.features) ? e.data.features : []).map(function (e) {
        var t = null;
        return e.bbox && (t = [[parseFloat(e.bbox[1]), parseFloat(e.bbox[0])], [parseFloat(e.bbox[3]), parseFloat(e.bbox[2])]]), {
          x: Number(e.center[0]),
          y: Number(e.center[1]),
          label: e.place_name ? e.place_name : e.text,
          bounds: t,
          raw: e
        };
      });
    }, t;
  }(x),
  D = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      void 0 === t && (t = {}), (r = e.call(this, t) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://api-adresse.data.gouv.fr";
      return r.searchUrl = t.searchUrl || n + "/search", r.reverseUrl = t.reverseUrl || n + "/reverse", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query;
      return this.getUrl(e.type === h.REVERSE ? this.reverseUrl : this.searchUrl, "string" == typeof t ? {
        q: t
      } : t);
    }, n.parse = function (e) {
      return e.data.features.map(function (e) {
        return {
          x: e.geometry.coordinates[0],
          y: e.geometry.coordinates[1],
          label: e.properties.label,
          bounds: null,
          raw: e
        };
      });
    }, t;
  }(x),
  B = /*#__PURE__*/function (e) {
    function t(t) {
      var r;
      void 0 === t && (t = {}), (r = e.call(this, t) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://api.geoapify.com/v1/geocode";
      return r.searchUrl = t.searchUrl || n + "/search", r.reverseUrl = t.reverseUrl || n + "/reverse", r;
    }
    r(t, e);
    var n = t.prototype;
    return n.endpoint = function (e) {
      var t = e.query,
        r = e.type,
        n = "string" == typeof t ? {
          text: t
        } : t;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (e) {
      return (Array.isArray(e.data.results) ? e.data.results : [e.data.results]).map(function (e) {
        return {
          x: Number(e.lon),
          y: Number(e.lat),
          label: e.formatted,
          bounds: [[parseFloat(e.bbox.lat1), parseFloat(e.bbox.lon1)], [parseFloat(e.bbox.lat2), parseFloat(e.bbox.lon2)]],
          raw: e
        };
      });
    }, t;
  }(x);
export { k as BingProvider, M as CivilDefenseMapProvider, U as EsriProvider, D as GeoApiFrProvider, w as GeoSearchControl, B as GeoapifyProvider, S as GeocodeEarthProvider, A as GoogleProvider, N as HereProvider, x as JsonProvider, I as LegacyGoogleProvider, O as LocationIQProvider, _ as MapBoxProvider, q as OpenCageProvider, F as OpenStreetMapProvider, L as PeliasProvider, w as SearchControl, v as SearchElement };